import React, { useState } from "react"

const TravelsContext = React.createContext([{}, () => {}])

const TravelsProvider = ({ children }) => {
  const [state, setState] = useState({ travels: [], tripCount: 0 })
  return <TravelsContext.Provider value={{ state, setState }}>{children}</TravelsContext.Provider>
}

export { TravelsContext, TravelsProvider }
